import React, { Fragment } from 'react'
import { DI } from 'modules'
import { Modal } from 'components/modal'
import { copy } from 'utils/buffer'

class TargetItem extends React.Component {
  state = {
    confirm: false,
    target: this.props.data,
  }

  checkStatusInitTime = 15

  componentDidMount() {
    if (
      this.state.target.status === 'created' ||
      this.state.target.status === 'starting'
    ) {
      this.checkStatus()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  setConfirm(confirm) {
    this.setState({ confirm })
  }

  destroy() {
    this.props.actions.targets.destroyTarget(
      this.props.slug,
      this.state.target.id
    )
    this.props.afterDestroy()
  }

  copyHlsLink = link => {
    copy(link)
    this.props.actions.notifications.createNotification({
      type: 'success',
      children: this.props.common.strings['after_copy_link'],
    })
  }

  checkStatus() {
    this.timeout = setTimeout(() => {
      this.props.actions.targets.getTarget(this.state.target.id).then(resp => {
        const { status, hls_playback_url } = resp.body
        if (
          status === 'created' ||
          status === 'starting' ||
          !hls_playback_url
        ) {
          this.checkStatus()
        }
        this.setState({ target: resp.body })
      })
    }, this.checkStatusInitTime * 1000)
    if (this.checkStatusInitTime > 5) {
      --this.checkStatusInitTime
    }
  }

  render() {
    const strings = this.props.common.strings
    const { target } = this.state

    return (
      <Fragment>
        <div className="live-target-item">
          <div
            className="live-target__item"
            style={{
              backgroundColor:
                target.target_type === 'hls_dvr'
                  ? '#1f7bbc'
                  : this.backgroundColor,
            }}
          >
            {target.target_type === 'hls_dvr' && (
              <div className="live-target-buttons">
                <a
                  target={'_blank'}
                  href={this.state.target.hls_playback_url}
                  className="live-target__item-hls"
                >
                  {strings['page.lives.view.add_stream.hls.open_link']}
                </a>
                <div className="live-target-or"> </div>
                <button
                  type="button"
                  onClick={() =>
                    this.copyHlsLink(this.state.target.hls_playback_url)
                  }
                  className="live-target__item-hls"
                >
                  {strings['page.lives.view.add_stream.hls.copy_link']}
                </button>
              </div>
            )}

            {target.target_type !== 'hls_dvr' && (
              <span>{this.props.data.name}</span>
            )}

            <button
              type="button"
              className="text-button"
              onClick={() => this.setConfirm(true)}
              title={
                target.target_type === 'hls_dvr'
                  ? strings['page.lives.view.add_stream.hls.delete_title']
                  : ''
              }
            >
              <span class="live-target__item-close"></span>
            </button>
          </div>

          {this.state.confirm && (
            <Modal>
              <div className="popup-tip">
                <span className="popup__title">
                  {target.target_type === 'hls_dvr'
                    ? strings['page.lives.view.del_stream.hls_title']
                    : strings['page.lives.view.del_stream.title']}
                </span>
                <div className="popup-buttons">
                  <Button
                    className="text-button"
                    onClick={() => this.setConfirm(false)}
                    text={strings['page.lives.view.del_stream.no']}
                  />
                  <Button
                    onClick={() => this.destroy()}
                    text={strings['page.lives.view.del_stream.yes']}
                  />
                </div>
              </div>
            </Modal>
          )}
        </div>
      </Fragment>
    )
  }

  get backgroundColor() {
    switch (this.state.target.status) {
      case 'created':
      case 'starting':
        return '#999999'
      case 'active':
        return '#00b404'
      default:
        return '#FF0000'
    }
  }
}

function Button(props) {
  const {
    type = 'button',
    className = 'button',
    onClick = () => {},
    text = '',
  } = props
  return (
    <div className="popup-button">
      <button type={type} onClick={onClick} className={className}>
        {text}
      </button>
    </div>
  )
}

export default DI(['targets', 'notifications'])(TargetItem)
